import { InputWrapper } from "./InputWrapper";
import { forwardRef, useRef } from "react";
import { getKeyByValue, parseUtils } from "../../data-parsing/parseUtils";

export function CreationForm({
  createFunction = () => {},
  afterSubmit = () => {},
  validateForm = () => {
    return true;
  },
  children,
  ...other
}) {
  const formRef = useRef();

  async function handleSubmit(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    /*     console.log("ev", ev);
     */ let formData = new FormData(formRef?.current);
    if (!validateForm(formData)) {
      return;
    }
    let parsedData = parseUtils(formRef);
    let newElement = await createFunction(parsedData[0]);
    afterSubmit(newElement, parsedData);
  }

  return (
    <form ref={formRef} onSubmit={handleSubmit} {...other}>
      {children}
    </form>
  );
}

export function CreationFormTemplate({
  formTemplate,
  dataTemplate,
  defaultData = {},
  ...other
}) {
  return formTemplate.sections.map((section, index) => {
    return [
      section.title && (
        <div key={`title${index}`} className="container-group col-sm-12">
          <h4 className="m-t-10 m-b-0">{section.title}</h4>
          <hr className="m-t-10" />
        </div>
      ),
      <div key={`section${index}`} className="p-t-5">
        {section.inputs?.map((input, index) => {
          const { type, ...rest } = input;
          const name = getKeyByValue(dataTemplate, input);
          return (
            <div
              key={`section${index}input${index}`}
              className={`form-group col-sm-${12 * section.size}`}
            >
              <InputWrapper
                type={type}
                name={name}
                required={true}
                autoComplete={"off"}
                defaultValue={defaultData[name]}
                metadata={{ ...rest }}
                showLabel={true}
                compact={section?.compact}
                {...other}
              />
            </div>
          );
        })}
      </div>,
    ];
  });
}
export const CreationFormInput = forwardRef((props, ref) => {
  const { inputData, style, ...rest } = props;
  const { type, ...data } = inputData;
  return (
    <div className={`form-group col-sm-${12 * props.size}`} style={style}>
      <InputWrapper
        ref={ref}
        type={inputData.type} /*required={true}*/
        autoComplete={"off"}
        {...rest}
        metadata={{ ...data }}
        showLabel={true}
        compact={true}
      />
    </div>
  );
});
